const grey = {
  50: "#ECECEC",
  100: "#D9D9D9",
  200: "#C5C5C5",
  300: "#B3B3B3",
  400: "#9F9F9F",
  500: "#8C8C8C",
  600: "#797979",
  // 700 and above text is WCAG AA accessible on white backgrounds.
  700: "#666666",
  // 800 and above text is WCAG AAA accessible on white backgrounds.
  800: "#535353",
  900: "#404040"
};

export default grey;
